import modelBaseV2 from "../model-base-v2.model";

const AttendanceModel = {

    getAttendance: function (filter) {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get(`/api/attendance?${qs}`, {}, true);
    },

    getAttendanceWorkType: function (filter) {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get(`/api/attendance/worktype?${qs}`);
    },

    getAttendanceCheckInOut: function (filter) {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get(`/api/attendance/checkinout?${qs}`);
    },

    getAttendanceAbnormal: function (filter) {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get(`/api/attendance/abnormal?${qs}`);
    },

    downloadAttendance: function (params, fileName) {
        return modelBaseV2.postDownload('/api/attendance', { body: params }, fileName);
    },

    downloadCheckInOutTemplate: function () {
        return modelBaseV2.getDownload('/api/attendance/template/download', null, 'attendance-check-in-out-template.xlsx');
    },

    uploadCheckInOutTemplate: function (formData) {
        return modelBaseV2.postDownload('/api/attendance/template/upload', { body: formData }, "attendance-check-in-out-upload-result.xlsx");
    },
}

export default AttendanceModel;
